export default __webpack_public_path__ + "static/media/Google.8dea7bd8.png";